import AppWidget_LoaderComponent from '@wix/thunderbolt-elements/src/components/AppWidget/viewer/skinComps/Loader/Loader.skin';


const AppWidget_Loader = {
  component: AppWidget_LoaderComponent
};


export const components = {
  ['AppWidget_Loader']: AppWidget_Loader
};

